// extracted by mini-css-extract-plugin
module.exports =  {"switch":"_0d624b9a27--switch--WlT9Z","indicator":"_0d624b9a27--indicator--qrsk6","label":"_0d624b9a27--label--L_Whq"};